export default __webpack_public_path__ + "static/media/expan.b93ad2ea.svg";